
import React from "react";
import { Container , Col , Row } from "reactstrap";
import Commonsection from "../component/UI/Common-section/Commonsection";
import Nftcards from "../component/UI/Nftards/Nftcards";
import  ava04  from  '../assets/images/ava-01.png';
import img04  from  '../assets/images/img-04.jpg';
import  '../Styles/create.css';


function  Create () {

    const item =  {
        id: "04",
        title: "Guard",
        desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia, nostrum et deleniti vero corrupti facilis minima laborum nesciunt nulla error natus saepe illum quasi ratione suscipit tempore dolores. Recusandae, similique modi voluptates dolore repellat eum earum sint.",
        imgUrl: img04,
        creator: "Trista Francis",
        creatorImg: ava04,
        currentBid: 7.89,
    }
    
    return(
        <>
            <Commonsection   title="Create Item"  />
            <section  className="">
                <Container  >
                    <Row >
                        <Col lg="3"  md="4"  sm="6" >
                            <h5  className="mb-4  text-light "> Preview Items </h5>
                            <Nftcards  item={item} />
                        </Col>

                        <Col  lg="9"  md="8"  sm="6" className="">
                            <div  className="create__item">
                                <form  className="  "  >
                                    <div  className="form__input ">
                                        <label  htmlFor="" className="">  Upload File </label>
                                        <input  type="file"    className="upload__input"  placeholder="Choos File.. " />
                                    </div>

                                    <div  className="form__input">
                                        <label  htmlFor="" >   Price </label>
                                        <input  type="number"  placeholder="Enter Your Price For One Item (ETH)"      className="  "  />
                                    </div>

                                    <div  className="form__input">
                                        <label  htmlFor="" >   Minimum Bid </label>
                                        <input  type="number"  placeholder=" Enter minmum Bid "      className="  "  />
                                    </div>

                                    <div  className="d-flex  align-items-center  justify-content-between  ">
                                        <div  className="form__input    w-50 ">
                                            <label  htmlFor="" > Starting  Date </label>
                                            <input  type="date"  />
                                        </div>

                                        <div  className="form__input  w-50 ">
                                            <label  htmlFor="" >    Expiration  Date </label>
                                            <input  type="date"   />
                                        </div>
                                    </div>

                                    <div  className="form__input">
                                        <label  htmlFor="" >   Title  </label>
                                        <input  type="text"  placeholder=" Enter title  " />
                                    </div>

                                    <div  className="form__input">
                                        <label  htmlFor="" >   Descreption  </label>
                                        <textarea  
                                            name=""  
                                            id=""  
                                            rows="/" 
                                            placeholder=" Enter Descreption "  
                                            className="w-100"
                                        >
                                        </textarea>
                                    </div>
                                </form>
                            </div>

                        </Col>

                    </Row>
                </Container>
            </section>
        </>
    );

}

export  default  Create;


